import * as Yup from "yup"
import {
	address,
	dateOfBirth,
	fullName,
	matriculaConsular,
	nationality,
	passport,
	ssn,
	name,
	ein,
} from "../../../../utilities/validation"
import {einRegex, ssnRegex} from "../../../../utilities/validation"
import {CA_COUNTRY_CODE, caPostalCode, US_COUNTRY_CODE, usPostalCode} from "../../../../resources/address"

export const validationErrorMessages = {
	ein: ein,
	name: name,
	fullName: fullName,
	ssn: ssn,
	nationality: nationality,
	passport: passport,
	matriculaConsular: matriculaConsular,
	address: address,
	dateOfBirth: dateOfBirth,
	stateOfIncorporation: {
		required: "Please enter state of incorporation",
	},
}

export const birthDateValidation = Yup.date()
	.required(validationErrorMessages.dateOfBirth.required)
	.max(new Date(), validationErrorMessages.dateOfBirth.max)

export const fullNameValidation = Yup.object({
	first: Yup.string().required(validationErrorMessages.fullName.first.required),
	last: Yup.string().required(validationErrorMessages.fullName.last.required),
})

export const ssnValidation = Yup.string()
	.required(validationErrorMessages.ssn.required)
	.matches(ssnRegex, validationErrorMessages.ssn.invalid)

export const addressValidation = Yup.object({
	street: Yup.string().required(validationErrorMessages.address.street.required),
	city: Yup.string().required(validationErrorMessages.address.city.required),
	state: Yup.string().when("country", {
		is: (country: string) => [US_COUNTRY_CODE, CA_COUNTRY_CODE].includes(country),
		then: Yup.string().required(validationErrorMessages.address.state.required),
	}),
	postalCode: Yup.string()
		.required(validationErrorMessages.address.postalCode.required)
		.when("country", {
			is: US_COUNTRY_CODE,
			then: Yup.string().matches(usPostalCode, validationErrorMessages.address.postalCode.usInvalid),
		})
		.when("country", {
			is: CA_COUNTRY_CODE,
			then: Yup.string().matches(caPostalCode, validationErrorMessages.address.postalCode.caInvalid),
		}),
	country: Yup.string().required(validationErrorMessages.address.country.required),
})

export const nameValidation = Yup.string().required(validationErrorMessages.name.required)

export const einValidation = Yup.string().matches(einRegex, validationErrorMessages.ein.invalid)
